import React, { ComponentProps } from "react";

import Close from "public/icons/close-thick.svg";

import { Button } from "@/components/form/Button/Button";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { WithClassName } from "@/models/utils.models";
import { clsxm } from "@/utils/tailwindMerge";

type PropTypes = WithClassName & {
  onClose?: () => void;
  crossColor?: ComponentProps<typeof SvgIcon>["color"];
  svgIconProps?: ComponentProps<typeof SvgIcon>;
  absolute?: boolean;
};

export const ModalCloseCross: React.FC<PropTypes> = ({
  onClose,
  className,
  crossColor = "light-grey",
  svgIconProps,
  absolute,
}) => {
  return (
    <div
      className={clsxm(
        "flex justify-end",
        !!absolute && "absolute right-4 top-4",
        className,
      )}
    >
      <Button
        aria-label="Close modal"
        variant="text"
        className="rounded-full"
        onClick={onClose}
      >
        <SvgIcon color={crossColor} width={20} height={20} {...svgIconProps}>
          <Close />
        </SvgIcon>
      </Button>
    </div>
  );
};
